import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid h-100 p-0" }
const _hoisted_2 = { class: "row h-100 g-0" }
const _hoisted_3 = { class: "col-12 h-100" }
const _hoisted_4 = {
  class: "overflow-y-auto h-100 pt-4 px-3",
  style: {"height":"calc(100vh - 60px)"}
}
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_6 = { class: "h4 fw-semibold mb-0" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  class: "card mb-5 mt-4",
  style: {"border":"none","background-color":"var(--color-light-light-gray)"}
}
const _hoisted_9 = {
  class: "card-header bg-light pt-4",
  style: {"background-color":"var(--color-light-light-gray) !important","border-bottom":"none"}
}
const _hoisted_10 = { class: "h5 mb-1" }
const _hoisted_11 = {
  class: "card-body pb-4",
  style: {"background-color":"var(--color-light-light-gray)"}
}
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "form-check mb-2" }
const _hoisted_15 = {
  class: "form-check-label",
  for: "includeRenewInverter"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-check mb-2" }
const _hoisted_19 = {
  class: "form-check-label",
  for: "includeRenewInverter"
}
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-check mb-2" }
const _hoisted_24 = {
  class: "form-check-label",
  for: "includeCashFlow"
}
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "mb-2" }
const _hoisted_27 = { class: "form-label mb-1" }
const _hoisted_28 = { class: "row mt-3" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-check form-check-inline" }
const _hoisted_31 = {
  class: "form-check-label",
  for: "paymentTypeSingle"
}
const _hoisted_32 = { class: "form-check form-check-inline" }
const _hoisted_33 = {
  class: "form-check-label",
  for: "paymentTypeInstallment"
}
const _hoisted_34 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "text-end mt-4" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "mb-4" }
const _hoisted_45 = { class: "h4 fw-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportComponent = _resolveComponent("ReportComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("project.previewAndReport.title")), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm",
                style: {"height":"38px","padding-top":"8px","padding-bottom":"8px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generatePDF && _ctx.generatePDF(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.exportPdf")) + " ", 1),
                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-file-earmark-pdf ms-1" }, null, -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("project.previewAndReport.selectSections")), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              (
                  [
                    'product_supply',
                    'product_supply_commissioning',
                    'full_service',
                  ].includes(_ctx.serviceType)
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: "includeRenewInverter",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.includeSections.renewInverter) = $event)),
                          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateRenewInverter && _ctx.updateRenewInverter(...args)))
                        }, null, 544), [
                          [_vModelCheckbox, _ctx.includeSections.renewInverter]
                        ]),
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("project.previewAndReport.sections.renewInverter")), 1)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "includeRenewInverter",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.includeSections.renewInverter) = $event)),
                            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateRenewInverter && _ctx.updateRenewInverter(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.includeSections.renewInverter]
                          ]),
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("project.previewAndReport.sections.renewInverter")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "includeCashFlow",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.includeSections.cashFlow) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.includeSections.cashFlow]
                              ]),
                              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("project.previewAndReport.sections.cashFlow")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("project.previewAndReport.sections.cashbackPercentage")), 1),
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCashbackPercentage) = $event)),
                                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateCashbackPercentage && _ctx.updateCashbackPercentage(...args)))
                              }, _cache[16] || (_cache[16] = [
                                _createElementVNode("option", { value: "0" }, "0%", -1),
                                _createElementVNode("option", { value: "36" }, "36%", -1),
                                _createElementVNode("option", { value: "50" }, "50%", -1)
                              ]), 544), [
                                [_vModelSelect, _ctx.selectedCashbackPercentage]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            id: "paymentTypeSingle",
                            value: "one_time",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.paymentType) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.paymentType]
                          ]),
                          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("project.previewAndReport.paymentType.single")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            id: "paymentTypeInstallment",
                            value: "installment",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.paymentType) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.paymentType]
                          ]),
                          _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("project.previewAndReport.paymentType.installment")), 1)
                        ])
                      ]),
                      (_ctx.paymentType === 'installment')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedInstallmentRatio) = $event)),
                                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateInstallmentRatio && _ctx.updateInstallmentRatio(...args)))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipmentStore.installmentRatios, (ratio) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: ratio.id,
                                      value: ratio.value
                                    }, _toDisplayString(ratio.value) + "% ", 9, _hoisted_37))
                                  }), 128))
                                ], 544), [
                                  [_vModelSelect, _ctx.selectedInstallmentRatio]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedYears) = $event)),
                                  onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.updateInstallmentDuration && _ctx.updateInstallmentDuration(...args)))
                                }, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (year) => {
                                    return _createElementVNode("option", {
                                      key: year,
                                      value: year
                                    }, _toDisplayString(year) + " " + _toDisplayString(year === 1
                                ? _ctx.$t("project.previewAndReport.years.singular")
                                : _ctx.$t("project.previewAndReport.years.plural")), 9, _hoisted_39)
                                  }), 64))
                                ], 544), [
                                  [_vModelSelect, _ctx.selectedYears]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64)),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  style: {"height":"38px","padding":"8px 20px","background-color":"var(--primary-color)","border-color":"var(--primary-color)"},
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.updatePreview && _ctx.updatePreview(...args))),
                  disabled: _ctx.isUpdating
                }, [
                  (_ctx.isUpdating)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                        _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.updatePreview")) + " ", 1),
                        _cache[17] || (_cache[17] = _createElementVNode("span", {
                          class: "spinner-border spinner-border-sm ms-2",
                          role: "status",
                          "aria-hidden": "true"
                        }, null, -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_43, [
                        _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.updatePreview")) + " ", 1),
                        _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-arrow-repeat ms-1" }, null, -1))
                      ]))
                ], 8, _hoisted_41)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("h2", _hoisted_45, _toDisplayString(_ctx.$t("project.previewAndReport.preview")), 1)
          ]),
          _createVNode(_component_ReportComponent, {
            "project-data": _ctx.projectData,
            "include-sections": _ctx.includeSections,
            "consumption-data": _ctx.consumptionData,
            "selected-panels": _ctx.selectedPanels,
            "selected-inverters": _ctx.selectedInverters,
            "selected-batteries": _ctx.selectedBatteries,
            selectedEVChargers: _ctx.selectedEVChargers,
            "selected-meters": _ctx.selectedMeters,
            "payment-type": _ctx.paymentType,
            "get-panel-device-count": _ctx.getPanelDeviceCount,
            "get-inverter-device-count": _ctx.getInverterDeviceCount,
            "get-battery-device-count": _ctx.getBatteryDeviceCount,
            getEVChargerDeviceCount: _ctx.getEVChargerDeviceCount,
            "get-meter-device-count": _ctx.getMeterDeviceCount
          }, null, 8, ["project-data", "include-sections", "consumption-data", "selected-panels", "selected-inverters", "selected-batteries", "selectedEVChargers", "selected-meters", "payment-type", "get-panel-device-count", "get-inverter-device-count", "get-battery-device-count", "getEVChargerDeviceCount", "get-meter-device-count"])
        ])
      ])
    ])
  ]))
}